import { clubbiStyled } from 'clubbi-ui'

export const StyledGroupedInvoiceCards = clubbiStyled('div')(({ theme }) => ({
  textAlign: 'center',
}))

export const StyledContainer = clubbiStyled('div')(({ theme }) => ({
  marginBottom: '30px',
}))

export const StyledDate = clubbiStyled('div')(({ theme }) => ({
  textAlign: 'left',
}))
